import React, { useState, useEffect } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";

//Assets
import assetInput_bg from "../../assets/assetInput_bg.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import loading_icon from "../../assets/loading_yellow.svg";
import { MOBILE } from "../../constants/breakpoints";

//actions

function VerifyModal() {
  const [assetAddress, setassetAddress] = useState<string>("");
  const dispatch = useDispatch();
  let wallet = useSelector((state: RootState) => state.walletState);

  const navigate = useNavigate();

  return (
    <section
      id="wc_bg"
      css={css`
        display: flex;
        width: 100%;
        height: 100vh;
        position: fixed;
        background: rgba(27, 31, 36, 0.74);
        z-index: 1000;
        justify-content: center;
        align-items: center;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 372px;
          height: 384px;
          background-color: white;
          padding: 64px;
          box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
            0px 64.8148px 46.8519px rgba(0, 0, 0, 0.0531481),
            0px 38.5185px 25.4815px rgba(0, 0, 0, 0.0425185),
            0px 20px 13px rgba(0, 0, 0, 0.035),
            0px 8.14815px 6.51852px rgba(0, 0, 0, 0.0274815),
            0px 1.85185px 3.14815px rgba(0, 0, 0, 0.0168519);
          border-radius: 24px;
          align-items: center;

          @media (max-width: ${MOBILE}px) {
            width: 90%;
            height: max-content;
            padding: 32px;
          }
        `}
      >
        <img
          css={css`
            width: 128px;
            height: 128px;
          `}
          src={loading_icon}
          alt=""
        />
        <h1
          css={css`
            font-weight: 700;
            font-size: 24px;

            @media (max-width: ${MOBILE}px) {
              font-size: 16px;
            }
          `}
        >
          Verifying
        </h1>
        <p
          css={css`
            font-weight: 400;
            font-size: 14px;
            text-align: center;
            margin: 0;
          `}
        >
          Once we confirm your token is safe in it's destination address your
          Proxy Token will be minted.
        </p>
      </div>
    </section>
  );
}

export default VerifyModal;
